import { apiGet, apiPost, apiPut, apiDelete, apiPostForm } from "./apiClient";

const BASE = "/rates";

function buildQuery(params = {}) {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null || value === "") return;

        // Column filters arrive as arrays; repeat the key so Spring binds a List.
        if (Array.isArray(value)) {
            value.forEach((item) => {
                if (item !== undefined && item !== null && item !== "") {
                    searchParams.append(key, item);
                }
            });
            return;
        }

        searchParams.append(key, value);
    });

    const query = searchParams.toString();
    return query ? `?${query}` : "";
}

export function getRatePermissions() {
    return apiGet(`${BASE}/permissions`);
}

export function getRates(params = {}) {
    return apiGet(`${BASE}${buildQuery(params)}`);
}

export function getRateFilterOptions() {
    return apiGet(`${BASE}/filter-options`);
}

export function getRateDetail(id) {
    return apiGet(`${BASE}/${id}`);
}

export function createRate(payload) {
    return apiPost(BASE, payload);
}

export function updateRate(id, payload) {
    return apiPut(`${BASE}/${id}`, payload);
}

export function deleteRate(id) {
    return apiDelete(`${BASE}/${id}`);
}

export function previewRateExcel(file) {
    const formData = new FormData();
    formData.append("file", file);
    return apiPostForm(`${BASE}/excel/preview`, formData);
}

export function importRateExcel(file) {
    const formData = new FormData();
    formData.append("file", file);
    return apiPostForm(`${BASE}/excel/import`, formData);
}
